import { trackAction } from './ab_track'

const CONFIG_ID = 'article-company-cta-config'
const SLOT = /^article_(?:above-contents|before-h2-\d+|below-contents)_/
const VARIANTS = ['control', 'company']

export function applyArticleCompanyCta() {
  const config = document.getElementById(CONFIG_ID)
  const variant = config?.dataset.variant
  if (!VARIANTS.includes(variant) || document.documentElement.dataset.articleCompanyCtaApplied) return

  const template = config.querySelector('template')
  if (!template) return
  const slots = [...document.querySelectorAll('[data-article-cta-placement]')]
    .filter(element => SLOT.test(element.dataset.articleCtaPlacement))
  if (!slots.length) return

  let middleCtaNumber = 0
  slots.forEach((slot, index) => {
    // 目次付近は変更せず、実際に表示されるH2付近のCTAを上から1番として数える。
    if (!/^article_before-h2-\d+_/.test(slot.dataset.articleCtaPlacement)) return
    middleCtaNumber += 1
    if (variant === 'control' || middleCtaNumber % 2 === 0) return

    const company = template.content.firstElementChild.cloneNode(true)
    company.dataset.placement = slot.dataset.articleCtaPlacement
    company.querySelectorAll('[data-region]').forEach(button => {
      const panel = company.querySelector(`[data-prefectures="${button.dataset.region}"]`)
      panel.id = `article-company-cta-${index}-${button.dataset.region}`
      button.setAttribute('aria-controls', panel.id)
    })
    company.classList.add('my-8')
    slot.replaceWith(company)
  })
  document.documentElement.dataset.articleCompanyCtaApplied = variant
  trackAction('article_cta_rendered', { path: location.pathname, variant, slots: slots.length })
}

export function handleArticleCompanyCta(event) {
  if (!(event.target instanceof Element)) return
  const company = event.target.closest('.article-company-cta')
  if (!company) return

  const link = event.target.closest('[data-prefectures] a')
  if (link && (event.type === 'click' || event.button === 1)) {
    // 通常リンクのまま計測し、Ctrl/⌘クリックや新しいタブで開く操作も保つ。
    const destination = new URL(link.href)
    trackAction('article_company_cta_clicked', {
      path: location.pathname,
      placement: company.dataset.placement,
      destination: destination.pathname + destination.search,
    })
    return
  }
  if (event.type !== 'click') return

  const regionButton = event.target.closest('[data-region]')
  const back = event.target.closest('[data-region-back]')
  if (!regionButton && !back) return

  const region = regionButton?.dataset.region
  const regions = company.querySelector('[data-regions]')
  const prefectures = company.querySelector('[data-prefecture-step]')
  company.querySelector('[data-region-slider]').dataset.prefectureOpen = String(Boolean(region))
  regions.inert = Boolean(region)
  regions.setAttribute('aria-hidden', String(Boolean(region)))
  prefectures.inert = !region
  prefectures.setAttribute('aria-hidden', String(!region))
  company.querySelector('[data-region-controls]').hidden = !region
  const prompt = company.querySelector('[data-region-prompt]')
  prompt.classList.toggle('invisible', Boolean(region))
  prompt.setAttribute('aria-hidden', String(Boolean(region)))
  company.querySelectorAll('[data-region]').forEach(button => button.setAttribute('aria-expanded', String(button.dataset.region === region)))
  if (region) {
    company.querySelectorAll('[data-prefectures]').forEach(panel => { panel.hidden = panel.dataset.prefectures !== region })
    company.dataset.selectedRegion = region
    company.querySelector(`[data-prefectures="${region}"] a`).focus({ preventScroll: true })
  } else {
    // 戻る間も都道府県を描画し、右へ戻るスライドを保つ。操作・読み上げはinertで止める。
    company.querySelector(`[data-region="${company.dataset.selectedRegion}"]`).focus({ preventScroll: true })
  }
}

export function initArticleCompanyCta() {
  if (document.documentElement.dataset.articleCompanyCtaInitialized) return
  document.documentElement.dataset.articleCompanyCtaInitialized = 'true'
  // session応答がbundleより先でも後でも適用し、別のhtmx応答では再設置しない。
  document.addEventListener('htmx:afterSettle', applyArticleCompanyCta)
  document.addEventListener('click', handleArticleCompanyCta)
  document.addEventListener('auxclick', handleArticleCompanyCta)
  applyArticleCompanyCta()
}
